import { Book } from "@/components/Svg";
import CSelect from "@/components/main/form/CSelect";
import firebase_app from "@/lib/firebase/configs";
import { Loader } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { IconBuildingCommunity } from "@tabler/icons-react";
import {
  addDoc,
  collection,
  endAt,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  startAt,
} from "firebase/firestore";
import { useEffect, useState } from "react";

const FieldOfStudyInput = ({ dictionary, form, clearable = false }) => {
  const [fieldsOfStudy, setFieldOfStudy] = useState([]);
  const [search, setSearch] = useDebouncedState("", 300);
  const [loading, setLoading] = useState(false);
  const createFieldOfStudy = async (type) => {
    try {
      const db = getFirestore(firebase_app);
      await addDoc(collection(db, "FieldsOfStudy"), {
        name: type,
        lowerCaseName: type.toLowerCase(),
      });
    } catch (error) {}
  };

  const getFieldOfStudy = async (search, inital = false) => {
    try {
      setLoading(true);
      const db = getFirestore(firebase_app);
      const q = inital
        ? query(
          collection(db, "FieldsOfStudy"),
          orderBy("lowerCaseName"),
          limit(4)
        )
        : query(
          collection(db, "FieldsOfStudy"),
          orderBy("lowerCaseName"),
          startAt(search.toLowerCase()),
          endAt(search.toLowerCase() + "\uf8ff"),
          limit(4)
        );
      const querySnapshot = await getDocs(q);
      let typesQueried = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        typesQueried.push(data?.name);
      });

      setFieldOfStudy(typesQueried);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFieldOfStudy("", true);
  }, []);

  useEffect(() => {
    if (search.length > 0) {
      getFieldOfStudy(search);
    }
  }, [search]);

  return (
    <CSelect
      searchable
      creatable
      clearable={clearable}
      data={
        form.values.fieldOfStudy
          ? Array.from(new Set([form.values.fieldOfStudy, ...fieldsOfStudy]))
          : fieldsOfStudy
      }
      placeholder={dictionary.fieldOfStudy}
      className="mt-3"
      icon={<Book />}
      onSearchChange={(query) => {
        setSearch(query);
      }}
      onCreate={(value) => {
        setFieldOfStudy((data) => [...data, value]);
        form.setFieldValue("type", value);
        createFieldOfStudy(value);
      }}
      getCreateLabel={(query) => {
        return (
          <>
            <span className="text-primary">{dictionary.createItem}: </span>
            {query}
          </>
        );
      }}
      rightSection={loading && <Loader variant="oval" />}
      {...form.getInputProps("fieldOfStudy")}
    />
  );
};

export default FieldOfStudyInput;
